// // reducer.ts
// import { createReducer, on } from '@ngrx/store';
// import { loadListSuccess, loadListFailure } from '../lib/action';
// import {loadObjectSuccess} from '../lib/action'

// // Define a type for list states with specific properties
// interface ListState {
//   application: any[];
//   country: any[];
//   data:any;
//   error: { [key: string]: any } | null; // Manage errors separately
// }

// export const initialState: ListState = {
//   application: [],
//   country: [],
//   data:null,
//   error: null,
// };

// export const listReducer = createReducer(
//   initialState,
//   on(loadListSuccess, (state, { listType, items }) => ({
//     ...state,
//     [listType]: items,
//     error: { ...state.error, [listType]: null }
//   })),
//   on(loadListFailure, (state, { listType, error }) => ({
//     ...state,
//     [listType]: [],
//     error: { ...state.error, [listType]: error }
//   }))
// );
// export const dataReducer = createReducer(
//   initialState,
//   on(loadObjectSuccess, (state, { data }) => {
//     return {
//       ...state,
//       data: data,
//     };
//   })
// );
import { createReducer, on } from '@ngrx/store';
import {
  loadListSuccess,
  loadListFailure,
  loadObjectSuccess,
  setListLoading
} from '../lib/action';

interface ListState {
  lists: { [key: string]: any[] };
  data: { [key: string]: any };
  loading: { [key: string]: boolean };
  error: { [key: string]: any };
}

export const initialState: ListState = {
  lists: {},
  data: {},
  loading: {},
  error: {}
};

export const listReducer = createReducer(
  initialState,
  on(loadListSuccess, (state, { listType, items }) => ({
    ...state,
    lists: { ...state.lists, [listType]: items },
    loading: { ...state.loading, [listType]: false },
    error: { ...state.error, [listType]: null }
  })),
  on(loadListFailure, (state, { listType, error }) => ({
    ...state,
    lists: { ...state.lists, [listType]: [] },
    loading: { ...state.loading, [listType]: false },
    error: { ...state.error, [listType]: error }
  })),
  on(loadObjectSuccess, (state, { listType, data }) => ({
    ...state,
    data: { ...state.data, [listType]: data },
    loading: { ...state.loading, [listType]: false },
    error: { ...state.error, [listType]: null }
  })),
  on(setListLoading, (state, { listType, isLoading }) => ({
    ...state,
    loading: { ...state.loading, [listType]: isLoading }
  }))
);
